module.exports = __webpack_public_path__ + "static/sitting-on-dock-ca0bd0ecc8b7bdeabe3c8c18a4a15888.jpg";